export default __webpack_public_path__ + "static/media/Vicious Cape of Ill Intent.c69449d2.jpg";